<kendo-dialog-titlebar>
    {{'claims-center.claimDocumentation.placeSignature' | translate}}
</kendo-dialog-titlebar>

<div #signDiv>
    <canvas #canvas class="signature-area" width="600px" height="200px"></canvas>
</div>
   

<kendo-dialog-actions>
    <button  type="button" [primary]="true" kendoButton (click)="confirm()">{{'global.save' | translate}}</button>
    <button  type="button" kendoButton (click)="clearSignPad()">{{'global.clean' | translate}}</button>
    <button  type="button" kendoButton (click)="cancel()">{{'global.cancel' | translate}}</button>
</kendo-dialog-actions> 